module.exports = __webpack_public_path__ + "img/Isolated_Bottle_Icon_Filled.b5d3e84a.png";